import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Crown, CheckCircle2 } from "lucide-react";

export default function PremiumSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refresh } = useAuth();
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      if (attempts >= 8) { setStatus("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); await refresh(); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        attempts += 1; setTimeout(poll, 2000);
      } catch { attempts += 1; setTimeout(poll, 2000); }
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="premium-success-page">
      {status === "paid" ? (
        <>
          <CheckCircle2 className="h-12 w-12 text-[#2E5C46] mx-auto mb-6" strokeWidth={1.25} />
          <h1 className="font-serif-display text-4xl mb-3">Welcome to Premium.</h1>
          <p className="text-[#5d574f] mb-8">Your subscription is active. Doors just opened.</p>
          <Link to="/browse" data-testid="success-browse-cta" className="rounded-full bg-[#C85A44] hover:bg-[#A84A36] text-white px-7 py-3 text-sm transition">
            Start discovering
          </Link>
        </>
      ) : status === "expired" || status === "error" ? (
        <>
          <h1 className="font-serif-display text-3xl mb-3">Payment didn't go through.</h1>
          <p className="text-[#8C857B] mb-8">Don't worry — you can try again.</p>
          <Link to="/premium" className="rounded-full bg-[#2C2A28] text-white px-7 py-3 text-sm">Back to plans</Link>
        </>
      ) : (
        <>
          <Crown className="h-10 w-10 text-[#C85A44] mx-auto mb-4 animate-pulse" strokeWidth={1.25} />
          <h1 className="font-serif-display text-3xl mb-2">Confirming your payment…</h1>
          <p className="text-sm text-[#8C857B]">This usually takes a few seconds.</p>
        </>
      )}
    </div>
  );
}
